import type { ContactContent, Branding } from '../../../lib/site-schema';

interface Props {
  content: ContactContent;
  branding: Branding | null;
  compact?: boolean;
}

export default function ContactSection({ content, branding, compact }: Props) {
  const primary = branding?.primaryColor || '#d97706';
  const secondary = branding?.secondaryColor || '#b45309';

  return (
    <div className={compact ? 'px-4 py-5' : 'px-6 py-10'}>
      {content.heading && (
        <div className="text-center mb-5">
          <h2
            className={`${compact ? 'text-sm' : 'text-xl'} font-bold`}
            style={{ color: '#292524', fontFamily: branding?.fontHeading, letterSpacing: '-0.01em' }}
          >
            {content.heading}
          </h2>
          <div className="w-10 h-0.5 mx-auto mt-2 rounded-full" style={{ background: primary }} />
        </div>
      )}
      <div className={`max-w-md mx-auto ${!compact ? 'grid grid-cols-1 md:grid-cols-2 gap-6' : ''}`}>
        <div
          className={`rounded-xl ${compact ? 'p-3 mb-3' : 'p-5'}`}
          style={{ background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}
        >
          <div className={`space-y-${compact ? '2' : '3'}`}>
            {content.address && (
              <div className="flex items-start gap-2.5">
                <span
                  className={`material-icons ${compact ? 'text-sm' : 'text-base'} mt-0.5 shrink-0`}
                  style={{ color: primary }}
                >
                  location_on
                </span>
                <span className={`${compact ? 'text-[10px]' : 'text-sm'}`} style={{ color: '#57534e' }}>
                  {content.address}
                </span>
              </div>
            )}
            {content.phone && (
              <div className="flex items-center gap-2.5">
                <span
                  className={`material-icons ${compact ? 'text-sm' : 'text-base'} shrink-0`}
                  style={{ color: primary }}
                >
                  phone
                </span>
                <span className={`${compact ? 'text-[10px]' : 'text-sm'} font-medium`} style={{ color: '#57534e' }}>
                  {content.phone}
                </span>
              </div>
            )}
            {content.email && (
              <div className="flex items-center gap-2.5">
                <span
                  className={`material-icons ${compact ? 'text-sm' : 'text-base'} shrink-0`}
                  style={{ color: primary }}
                >
                  email
                </span>
                <span className={`${compact ? 'text-[10px]' : 'text-sm'}`} style={{ color: '#57534e' }}>
                  {content.email}
                </span>
              </div>
            )}
          </div>
        </div>

        {content.showForm && !compact && (
          <div
            className="rounded-xl p-5 space-y-3"
            style={{ background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}
          >
            <div
              className="h-9 rounded-lg px-3 flex items-center text-xs"
              style={{ background: '#fafaf9', border: '1px solid #e7e5e4', color: '#d6d3d1' }}
            >
              Your name
            </div>
            <div
              className="h-9 rounded-lg px-3 flex items-center text-xs"
              style={{ background: '#fafaf9', border: '1px solid #e7e5e4', color: '#d6d3d1' }}
            >
              Email address
            </div>
            <div
              className="h-20 rounded-lg px-3 pt-2 text-xs"
              style={{ background: '#fafaf9', border: '1px solid #e7e5e4', color: '#d6d3d1' }}
            >
              Your message...
            </div>
            <button
              className="w-full h-9 rounded-lg text-xs font-semibold text-white transition-all hover:opacity-90"
              style={{ background: `linear-gradient(135deg, ${primary}, ${secondary})`, boxShadow: `0 2px 8px ${primary}30` }}
            >
              Send Message
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
